import { useAuth } from '../contexts/AuthContext.jsx';

export default function RoleGate({ roles, children, fallback = null }) {
  const { user } = useAuth();
  if (!user) return fallback;
  if (!roles || roles.length === 0) return children;
  if (!roles.includes(user.role)) return fallback;
  return children;
}
